import { createContext, useContext } from 'react';

const OrganizationIdContext = createContext<string | undefined>(undefined);

export const OrganizationIdProvider = OrganizationIdContext.Provider;

export const useOrganizationId = () => useContext(OrganizationIdContext);
